export default __webpack_public_path__ + "static/media/diagonal-mover-1.ba9e9196.svg";